// extracted by mini-css-extract-plugin
module.exports =  {"layout":"_33974c2b58--layout--dVaQU","spinner":"_33974c2b58--spinner--e_O7D","container":"_33974c2b58--container--M0xiL","error":"_33974c2b58--error--AcAkz"};